import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t bg-background/60 backdrop-blur-sm">
      <div className="mx-auto max-w-[1600px] px-4 md:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-6">
          {/* Copyright and branding */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span>©</span>
            <span>{new Date().getFullYear()}</span>
            <span className="font-medium">{t("main.copyRight")}</span>
          </div>

          {/* Status and version info */}
          <div className="flex items-center gap-4 text-sm">
            {/* System status indicator */}
            <div className="flex items-center gap-2 text-muted-foreground">
              <div className="h-2 w-2 rounded-full bg-green-500 animate-pulse" />
              <span className="hidden sm:inline">System Online</span>
            </div>

            {/* Version */}
            <span className="text-muted-foreground font-mono text-xs bg-muted px-2 py-1 rounded">
              v1.0.0
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
